export const MEDIAN_RT = { phonics: 2000, sight: 3000, stories: 8000, bubbles: 1500 };

export function isGuess(ms, mode) {
  if (!ms || ms < 300) return true;
  const median = MEDIAN_RT[mode] || 2000;
  if (ms < median * 0.15) return true;
  return false;
}

export function isPatternTapping(log) {
  if (!log || log.length < 5) return false;
  const last5 = log.slice(-5);
  const allFast = last5.every(e => e.ms < 500);
  const allSameResult = last5.every(e => e.c === last5[0].c);
  return allFast && allSameResult;
}

export function getTargetSuccessRate(age) {
  if (age <= 5) return { min: 0.90, max: 0.95 };
  if (age <= 8) return { min: 0.85, max: 0.90 };
  return { min: 0.80, max: 0.85 };
}

export function getRecentAccuracy(log, count) {
  if (!log || log.length === 0) return null;
  const recent = log.slice(-(count || 20));
  return recent.filter(r => r.c).length / recent.length;
}

export function getDifficultyAdjustment(accuracy, age) {
  if (accuracy === null) return 0;
  const target = getTargetSuccessRate(age);
  if (accuracy > target.max) return 1;
  if (accuracy < target.min) return -1;
  return 0;
}

export function calculateSQS(log) {
  if (!log || log.length < 10) return { sqs: 0, isAnomalous: false };
  const recent = log.slice(-20);
  const half = Math.floor(recent.length / 2);
  const first = recent.slice(0, half);
  const second = recent.slice(half);
  const acc = recent.filter(r => r.c).length / recent.length;
  const firstAcc = first.filter(r => r.c).length / first.length;
  const secondAcc = second.filter(r => r.c).length / second.length;
  const trend = secondAcc - firstAcc;
  const effortful = recent.filter(r => r.ms >= 300).length / recent.length;
  const sqs = (acc * 0.4) + (effortful * 0.3) + (1.0 * 0.2) + (Math.max(0, trend + 0.5) * 0.1);
  const isAnomalous = acc < 0.4 && effortful < 0.5;
  return { sqs, isAnomalous };
}

export function shouldEnterChillMode(log) {
  if (!log || log.length < 10) return false;
  const recent = log.slice(-10);
  const half = Math.floor(recent.length / 2);
  const first = recent.slice(0, half);
  const second = recent.slice(half);
  const firstAcc = first.filter(r => r.c).length / first.length;
  const secondAcc = second.filter(r => r.c).length / second.length;
  const firstRT = first.reduce((s, r) => s + (r.ms || 0), 0) / first.length;
  const secondRT = second.reduce((s, r) => s + (r.ms || 0), 0) / second.length;
  return secondAcc < firstAcc - 0.2 && secondRT > firstRT * 1.3;
}
